import { render, staticRenderFns } from "./buttons-control.vue?vue&type=template&id=28586dcb&scoped=true"
import script from "./buttons-control.vue?vue&type=script&lang=js"
export * from "./buttons-control.vue?vue&type=script&lang=js"
import style0 from "./buttons-control.vue?vue&type=style&index=0&id=28586dcb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28586dcb",
  null
  
)

export default component.exports